<template>
    <ToolButton :Editor="Editor" KnownIcon="Code" @ToolClick="ToggleInlineCode()">
        
    </ToolButton>
</template>
<script>

import ToolButton from '@/views/components/atoms/tiptap/Predefined/Buttons/ToolButton.vue';

export default ({
    components: {
        ToolButton
    },
    methods:{
        ToggleInlineCode(){
            if (this.Editor) {
                this.Editor.commands.toggleCode();
            }
        }
    },
    props: ["Editor"]
});
</script> 